import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { cn } from "lib/utils";

const OnboardingDrawer = ({
    isOpen,
    onClose,
    children,
    containerClassName,
    panelClassName,
    ariaLabel = "Details",
}) => {
    useEffect(() => {
        if (!isOpen) return undefined;

        const handleKeyDown = (event) => {
            if (event.key === "Escape") onClose?.();
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className={cn("fixed inset-0 z-50 flex justify-end bg-black/50", containerClassName)}
            onClick={onClose}
            role="presentation"
        >
            <motion.aside
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
                className={cn(
                    "relative h-full w-full max-w-xl overflow-auto bg-white shadow-lg",
                    panelClassName
                )}
                onClick={(event) => event.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-label={ariaLabel}
            >
                {children}
            </motion.aside>
        </div>
    );
};

export default OnboardingDrawer;
